module.exports = __webpack_public_path__ + "img/58-green.7ba491bb.svg";